import TldlBetaIcon from './TldlBetaIcon';

export default TldlBetaIcon;
